import { render, staticRenderFns } from "./cleaner-list.vue?vue&type=template&id=56515902&scoped=true&"
import script from "./cleaner-list.vue?vue&type=script&lang=js&"
export * from "./cleaner-list.vue?vue&type=script&lang=js&"
import style0 from "./cleaner-list.vue?vue&type=style&index=0&id=56515902&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56515902",
  null
  
)

export default component.exports